import { BellRinging, CheckCircle } from '@phosphor-icons/react'
import { useState } from 'react'
import Button from '@/src/components/core/Button'
import ErrorMessage from '@/src/components/core/ErrorMessage'
import { Input } from '@/src/components/core/Input'
import useLaravelForm from '@/src/hooks/useLaravelForm'

type WaitlistForm = {
  email: string
}

export default function CourseWaitlist({ courseSlug }: { courseSlug: string }) {
  const [expanded, setExpanded] = useState(false)
  const [success, setSuccess] = useState(false)
  const [sending, setSending] = useState(false)
  const { handleSubmit, register, errorMessage } =
    useLaravelForm<WaitlistForm>()

  if (success) {
    return (
      <p className="flex items-center gap-2 font-bold text-green-700">
        <CheckCircle size={20} weight="fill" className="shrink-0" />
        Wir schicken dir eine E-Mail, sobald ein Platz frei wird.
      </p>
    )
  }

  if (!expanded) {
    return (
      <div className="flex flex-col gap-3 @3xl:flex-row @3xl:items-center @3xl:justify-between">
        <p>Lass dich benachrichtigen, sobald ein Platz frei wird.</p>
        <Button
          version="purple-ghost"
          size="small"
          icon={<BellRinging weight="fill" />}
          onClick={() => setExpanded(true)}
          className="shrink-0 self-start @3xl:self-auto"
        >
          Benachrichtigen
        </Button>
      </div>
    )
  }

  return (
    <form
      method="POST"
      action={`${process.env.NEXT_PUBLIC_BLINK_ADMIN_URL}/api/website/v2/courses/${courseSlug}/waitlist`}
      onSubmit={handleSubmit(
        () => {
          setSending(false)
          setSuccess(true)
        },
        (data) => {
          setSending(true)

          // The email links back to this course list.
          return {
            ...data,
            url: `${window.location.origin}${window.location.pathname}`,
          }
        },
        () => setSending(false)
      )}
    >
      <p className="font-bold">Benachrichtigung bei freiem Platz</p>
      <p className="mt-1 text-sm">
        Wir schicken dir eine E-Mail, sobald ein Platz frei wird. Angemeldet
        bist du damit noch nicht: Der Platz geht an die Person, die zuerst
        bucht.
      </p>
      <div className="mt-4 flex flex-col gap-3 @3xl:flex-row @3xl:items-start">
        <div className="grow">
          <Input
            label="E-Mail"
            kind="email"
            color="white"
            autoFocus
            {...register('email')}
          />
        </div>
        <Button type="submit" loading={sending} className="shrink-0 @3xl:mt-1">
          Benachrichtigen
        </Button>
      </div>
      {errorMessage && (
        <div className="mt-2">
          <ErrorMessage>{errorMessage}</ErrorMessage>
        </div>
      )}
    </form>
  )
}
